$(document).ready(function () {
  //mega menu hover
  $(".mega-menu-row").each(function () {
    $(this).hover(function () {
      $(this).parent().find(".mega-menu-row").removeClass("show");
      $(this).addClass("show");
    });
  });

  // slick slider
  if ($(".slick-slider").length) {
    $(".slick-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      fade: true,
      arrows: false,
      dots: false,
    });
  }

  if ($(".product-media-slider").length) {
    $(".product-media-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      asNavFor: ".thumbnail-slider",
    });
  }

  if ($(".thumbnail-slider").length) {
    $(".thumbnail-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      asNavFor: ".product-media-slider",
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
  }

  if ($(".mini-slider").length) {
    setTimeout(function () {
      $(".mini-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    }, 1000);
  }

  if ($(window).width() < 768) {
    if ($(".slick-mobile").length) {
      $(".slick-mobile").slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        centerMode: true,
      });
    }
  }
  //readmore scroll to div
  $(".read-more").click(function () {
    var header_h = $(".header").innerHeight();
    var target = $(this).data("target");
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top - header_h,
      },
      100
    );
  });

  //click event for search
  $(document).on("click", ".show-search", function () {
    // $(".header-search-global").addClass("open-search");
    $("#header-global-search-input").trigger("click");
  });

  $(document).on("click", ".close-search", function () {
    $(".header-search-global").removeClass("open-search");
  });

  //collection page click event
  $(document).on("click", ".show-hover-content", function () {
    $(this).parents(".card").addClass("show");
  });
  $(document).on("click", ".hide-hover-content", function () {
    $(this).parents(".card").removeClass("show");
  });

  //wrap price div
  // setTimeout(function () {
  //   var $hulkappDiv = $(".hulkapps-volumes").find('div');
  //   // if ($hulkappDiv.length > 0) {
  //   //   $(".hulkapps-volumes .offer-options-title").text("Bulk Pricing");
  //   // }
  //   // $hulkappDiv.wrapAll('<div class="accordion-wrap"></div>');
  //   // $(".accordion-wrap").prepend("<span>Bulk Pricing</span>");
  // }, 1000);
});
//contact page
$(document).ready(function () {
  const params = new URLSearchParams(window.location.search);
  const scroll = params.get("scroll"); // Replace 'scroll' with your parameter name
  if (scroll == "bulk") {
    $("#bulk button").click(); // Trigger the click
  }
  if (scroll == "hour") {
    $("#hour button").click(); // Trigger the click
  }
  var header_h = $(".header").innerHeight();
  if (scroll) {
    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: $("#" + scroll).offset().top - header_h, // Ensure the element has the same ID as the parameter value
        },
        "slow"
      );
    }, 100);
  }
});

// $(document).on(
//   "click",
//   '.product .product-info-wrap-content .offer-option-item input[type="radio"]',
//   function () {
//     $("#card-list-button").trigger("click");
//   }
// );

// Updated logic for hulk discount
$(document).ready(function () {

  // Updating GST for PDP
  const radioSelector =
    ".product .product-info-wrap-content .offer-option-item input[type='radio']";
  const quantityInputSelector =
    ".product-actions-add-to-cart .quantity-input .quantity-input-field";
  const offerOptionItemSelector =
    ".product .product-info-wrap-content .offer-option-item";
  const offerPriceSelector = ".offer-option_txt .offer-option .money";
  const regularPriceSelector = ".offer-option_price .item-regular_price .money";
  const totalWithoutDiscount =
    ".offer-option_price .option-total-price .total-compare_price .money";
  const totalWithDiscount =
    ".offer-option_price .option-total-price .total-regular_price .money";

  const extractPrice = (selector) => {
    return parseFloat(
      $(selector)
        .text()
        .replace(/[^0-9.-]+/g, "")
    );
  };

  const updateOfferText = ($offerText, difference) => {
    let offerTextContent = $offerText.text().trim();
    if (offerTextContent.includes("%")) {
      offerTextContent = offerTextContent.replace(
        /\d+%/,
        `$${difference.toFixed(2)}`
      );
      $offerText.text(offerTextContent);
    }
  };

  function uncheckRadioButton() {
    const $offerItems = $(offerOptionItemSelector);
    if ($offerItems.length) {
      $offerItems.each(function () {
        const $this = $(this);
        [offerPriceSelector, regularPriceSelector].forEach((selector) => {
          $this.find(selector).each(function () {
            let text = $(this).text().trim();
            if (!text.includes(" Inc. GST")) {
              $(this).html(`${text}  Inc. GST`);
            }
          });
        });
        $(radioSelector).prop("checked", false);
        const totalWithoutDiscountValue = extractPrice(
          $this.find(totalWithoutDiscount)
        );
        const totalWithDiscountValue = extractPrice(
          $this.find(totalWithDiscount)
        );
        const difference = totalWithoutDiscountValue - totalWithDiscountValue;
        const $offerText = $this.find(".offer-option_txt .offer-option p");
        if ($offerText.length) {
          updateOfferText($offerText, difference);
        }
      });
    }
  }

  document.addEventListener("hulkEvent", function (event) {
    uncheckRadioButton();
  });

  // function uncheckRadioButton() {
  //   const targetNode = document.body;
  //   const config = { childList: true, subtree: true };
  //   const observer = new MutationObserver(() => {
  //     const $offerItems = $(offerOptionItemSelector);
  //     if ($offerItems.length) {
  //       $offerItems.each(function () {
  //         const $this = $(this);
  //         [offerPriceSelector, regularPriceSelector].forEach((selector) => {
  //           $this.find(selector).each(function () {
  //             let text = $(this).text().trim();
  //             if (!text.includes(" Inc. GST")) {
  //               $(this).html(`${text}  Inc. GST`);
  //             }
  //           });
  //         });
  //         $(radioSelector).prop("checked", false);
  //         const totalWithoutDiscountValue = extractPrice(
  //           $this.find(totalWithoutDiscount)
  //         );
  //         const totalWithDiscountValue = extractPrice(
  //           $this.find(totalWithDiscount)
  //         );
  //         const difference = totalWithoutDiscountValue - totalWithDiscountValue;
  //         const $offerText = $this.find(".offer-option_txt .offer-option p");
  //         if ($offerText.length) {
  //           updateOfferText($offerText, difference);
  //         }

  //         observer.disconnect();
  //       });
  //     }
  //   });
  //   observer.observe(targetNode, config);
  // }

  function updateQuantityFromSelectedOption() {
    const selectedRadio = $(radioSelector + ":checked");
    if (selectedRadio.length) {
      $(quantityInputSelector).val(selectedRadio.val());
    }
  }
  $(document).on("click", radioSelector, updateQuantityFromSelectedOption);

  // Updating GST for cart
  const miniCartItemSelector =
    ".mini-cart-wrap .mini-cart-inner .mini-cart-item.js-cart-item";
  const mainCartSelector =
    ".main-cart-items .cart-items .cart-item.js-cart-item";
  const cartItemDiscountedPrice = ".discounted_price";
  const cartItemOriginalPrice = ".original_price";
  let gstInterval;
  
  //Updating cart drawer GST
  function updateCartDrawerGST() {
    const cartTotalOriginalPrice =
      "#mini-cart-totals [data-hulkapps-cart-total]";
    const cartTotalDiscountedPrice = "#mini-cart-totals .hulkapps-cart-total";
    if (gstInterval) {
      clearInterval(gstInterval);
    }
    gstInterval = setInterval(() => {
      const $cartItems = $(miniCartItemSelector);
      if ($cartItems.length) {
        [cartItemDiscountedPrice, cartItemOriginalPrice].forEach((selector) => {
          $cartItems.find(selector).each(function () {
            let text = $(this).text().trim();
            if (!text.includes(" Inc. GST")) {
              $(this).html(`${text}  Inc. GST`);
            }
          });
        });
      }
      const $cartTotal = $(cartTotalOriginalPrice);
      const $cartTotalDiscounted = $(cartTotalDiscountedPrice);

      const updateTotalWithGST = ($element) => {
        let totalText = $element.text().trim();
        if (!totalText.includes(" Inc. GST")) {
          $element.html(`${totalText}  Inc. GST`);
        }
      };
      updateTotalWithGST($cartTotal);
      updateTotalWithGST($cartTotalDiscounted);
    }, 500);

    $(".button-drawer-header-dismiss").on("click", function () {
      clearInterval(gstInterval);
    });
  }

  //Updating main cart GST
  function updateMainCartGST() {
    const cartTotalOriginalPrice =
      ".cart-footer .totals [data-hulkapps-cart-total]";
    const cartTotalDiscountedPrice =
      ".cart-footer .totals .hulkapps-cart-total";
    if (gstInterval) {
      clearInterval(gstInterval);
    }
    gstInterval = setInterval(() => {
      const $mainCartItems = $(mainCartSelector);
      if ($mainCartItems.length) {
        [cartItemDiscountedPrice, cartItemOriginalPrice].forEach((selector) => {
          $mainCartItems.find(selector).each(function () {
            let text = $(this).text().trim();
            if (!text.includes(" Inc. GST")) {
              $(this).html(`${text}  Inc. GST`);
            }
          });
        });
      }
      const $cartTotal = $(cartTotalOriginalPrice);
      const $cartTotalDiscounted = $(cartTotalDiscountedPrice);

      const updateTotalWithGST = ($element) => {
        let totalText = $element.text().trim();
        if (!totalText.includes(" Inc. GST")) {
          $element.html(`${totalText}  Inc. GST`);
        }
      };
      updateTotalWithGST($cartTotal);
      updateTotalWithGST($cartTotalDiscounted);
    }, 500);

    $(".button-drawer-header-dismiss").on("click", function () {
      clearInterval(gstInterval);
    });
  }

  $("#mini-cart-toggle, .button-add-to-cart").on("click", function () {
    updateCartDrawerGST();
  });
  if (window.location.pathname.includes("/cart")) {
    updateMainCartGST();
  }
});

//Autoplay PDP video
document.addEventListener("DOMContentLoaded", function () {
  $(".product-media-slider").on("afterChange", function () {
    handleVideoPlayback();
  });

  setTimeout(() => {
    handleVideoPlayback();
  }, 500);

  function handleVideoPlayback() {
    let slides = document.querySelectorAll(
      ".product-media-wrapper .slick-slide"
    );

    // Stop all videos
    slides.forEach((slide) => {
      let iframe = slide.querySelector(".deferred-media iframe");
      if (iframe) {
        let videoSrc = iframe.getAttribute("src");
        if (
          videoSrc.includes("youtube.com") ||
          videoSrc.includes("vimeo.com")
        ) {
          let message = videoSrc.includes("youtube")
            ? { event: "command", func: "pauseVideo" } // YouTube API
            : { method: "pause" }; // Vimeo API
          iframe.contentWindow.postMessage(JSON.stringify(message), "*");
        }
      }
    });

    let activeSlide = document.querySelector(
      ".product-media-wrapper .slick-current"
    );
    let activeIframe = activeSlide?.querySelector(".deferred-media iframe");

    if (activeIframe) {
      let activeSrc = activeIframe.getAttribute("src");
      if (
        activeSrc.includes("youtube.com") ||
        activeSrc.includes("vimeo.com")
      ) {
        let message = activeSrc.includes("youtube")
          ? { event: "command", func: "playVideo" } // YouTube API
          : { method: "play" }; // Vimeo API
        activeIframe.contentWindow.postMessage(JSON.stringify(message), "*");
      }
    }

    let posterButton = activeSlide?.querySelector(
      ".deferred-media-poster-button"
    );
    if (posterButton) {
      posterButton.click();
    }
  }
});
